<ng-template #ReleaseNotes let-c="close" let-d="dismiss" class="el--popup">
    <div class="releasenotes" [ngClass]="{'search-active': isFrmSearch}">
        <div class="modal-header">
            <h4 class="modal-title release_notes_title"><i class="fa-kit-duotone fa-release-notes"></i>Release Notes</h4>
            <button type="button" [tabindex]="-1" class="close" aria-label="Close" (click)="d('Cross click')" (click)="releaseNotesClose()"><i class="fa fa-times close-button" aria-hidden="true"></i></button>
        </div>
        <div>
            <div class="row scrollwidth">
                <div class="menu ">
                    <div class="col-md-12 margin_top_1rem">
                        <div class="form-group has-search">
                             <span class="fa fa-search form-control-feedback" (click)="searchFeatures(searchTerm)"></span>
                            <eprx-input [RxSelectId]="'searchID'" [AutoFocus]="true"
                                    [LabelText]="''" [PlaceHolder]="'Search'" [InputValue]="searchTerm"
                                    [HasControl]="false" [cssStyle]="true"
                                    (TriggerOnEnterValue)="searchFeatures($event)" [releaseNotes]="true" (TriggerOnChange)="searchTerm = $event.target.value">
                            </eprx-input>
                        </div>
                    </div>
                    <button class="current-releases margin_top_1rem" (click)="getPagesForReleaseNotes('New Releases', true)">
                      New Releases
                    </button>
                    <div class="col-md-12 release-border">
                        <h6 class="col-md-12 pickbydate">Pick By Month/Year</h6>
                        <hr class="release_horizontal">
                        <div class="bookshelf--block--releasenotes release-scroll" #leftScrollContainer>
                            <div class="bookshelf w-95">
                                <div class="book-tilted-release" *ngFor="let option of months; let i = index" #monthItem>
                                    <div (click)="getPagesForReleaseNotes(option)" class="book--release">
                                        <div class="release-months d-flex align-items-center justify-content-between"
                                                [ngClass]="{'release-months-active': expandedMonth === option}">
                                            <span class="month-label">{{option}}</span>
                                            <i class="fa" [ngClass]="expandedMonth === option ? 'fa-chevron-down font_size_10px' : 'fa-chevron-right font_size_10px'"></i>
                                        </div>
                                    </div>
                                    <!-- Submenu for builds -->
                                    <div *ngIf="(expandedMonth === option && monthBuilds?.[option]?.length) || expandedMonth === 'New Releases'" class="submenu-builds submenu-scroll">
                                        <div class="submenu-list">
                                            <div *ngFor="let build of monthBuilds[option]"
                                                (click)="getReleaseNotesForBuild(build)"
                                                tabindex="0"
                                                (focus)="build.isFocused = true"
                                                (blur)="build.isFocused = false"
                                                (mouseenter)="build.isFocused = true"
                                                (mouseleave)="build.isFocused = false"
                                                [ngClass]="{'submenu-animate': build.isFocused}"
                                                (keydown.enter)="getReleaseNotesForBuild(build)">
                                                <span>{{build.Title}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 checkboxforrelease" [formGroup]="inputFg">
                        <input class="form-check-input" type="checkbox" formControlName="ShowReleasesAfterLogin" id="ShowReleasesAfterLogin"/>
                        <label class="form-check-label">
                            Do not pop-up after login
                        </label>
                    </div>
                </div>
                <div class="maincontent scrollbar">
                    <div *ngIf="!isFrmSearch">
                        <div>
                            <span class="header_txt" [innerHTML]="rnDataToDisplay" *ngIf ="hasRnData && !isConfluneceServiceNotAvailable" (click)="clickOnUserGuideLinks()"></span>
                        </div>
                    </div>
                    <div *ngIf="isFrmSearch">
                      <ul class="release-search-list" (scroll)="onSearchListScroll($event)">
                        <li *ngFor="let build of loadedNotes; let i = index">
                          <hr *ngIf="i !== 0">
                          <div *ngIf="build?.response">
                            <span class="header_txt" [innerHTML]="build.response" (click)="clickOnUserGuideLinks()"></span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="release-center-message">
                        <span *ngIf="!hasRnData && !isConfluneceServiceNotAvailable && loadedNotes?.length === 0">
                            <h1 class=""><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>No updates are available</h1>
                        </span>
                        <span *ngIf="isConfluneceServiceNotAvailable">
                            <h1 class=""><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                            Service Unavailable at the moment. Please re-try in sometime</h1>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-template>
